export default __webpack_public_path__ + "static/media/InfectionRisk.37b894f8.svg";